import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import FormControl from "@material-ui/core/FormControl";
import { Label } from "../../../../components/formInputs";
import { Checkbox, FormGroup, Grid, Tooltip, withStyles } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Info from "@material-ui/icons/Info";
import { ErrorCommon } from "../../../../components/formikFormInputs";
import { useFormikContext } from "formik";

const HtmlTooltip = withStyles(() => ({
    tooltip: {
        backgroundColor: "#2f2f2f",
        maxWidth: "500px",
        minWidth: "100px",
        color: "#ffccc",
        lineHeight: "18px",
        fontWeight: "normal",
        padding: "20px",
        margin: "0",
        boxShadow: "0 0 15px 0px #8c8c8c",
    },
}))(Tooltip);
type Props = {
    classes: Record<any, any>; // often used for Material-UI classes
    insureRef?: React.Ref<any>;       // if it’s a ref
    isFromClientDetail: boolean;     // boolean flag
    personalRadiolist: any[];     // array of strings, could be different depending on usage
    clientSigned?: boolean;           // boolean flag
    isGWTGen2?: boolean;              // boolean flag
    insuranceError?: string | null;   // string error message or null
};
// @Note this component is used for national-life and alliaz both
export default function PersonalInsuranceCheckBoxes(props: Props) {
    const { classes = {}, insureRef, isFromClientDetail, personalRadiolist, clientSigned, isGWTGen2, insuranceError } = props;
    const {values, setFieldValue, errors, touched} = useFormikContext<any>()



    return (
            <Grid item xs={12}>
                <FormControl
                        component="fieldset"
                        error={false}
                        className={classes.formControl + " mb20 "}
                >
                    <Typography ref={insureRef} id={"insureRef"} variant="body1" className="mt30 mb20" component="strong">
                        <Label label={"Personal Insurance"} required={!isFromClientDetail} />
                    </Typography>
                    <FormGroup
                            aria-label="personalInsurance"
                    >
                        <Grid container spacing={2}>
                            {
                                personalRadiolist && personalRadiolist.map((item, index) => {
                                    return (
                                            <Grid item xs={12} md={12} lg={6}>
                                                <FormControlLabel
                                                        key={ values["personalInsurance"] && values["personalInsurance"].includes(item.value).toString().concat(item.value)}
                                                        className="formikRadio ml0 mb0"
                                                        value={`${item.value}`}
                                                        disabled={!!clientSigned || isGWTGen2}
                                                        control={<Checkbox
                                                                key={values["personalInsurance"] && values["personalInsurance"].includes(item.value).toString().concat(item.value)}
                                                                color={"primary"}
                                                                className="padding0 mb0"
                                                                checked={values["personalInsurance"] && values["personalInsurance"].includes(item.value)}
                                                                onChange={e => {
                                                                    if (e.target.checked) {
                                                                        if(Array.isArray(values["personalInsurance"])) {
                                                                            setFieldValue("personalInsurance", [...values.personalInsurance, item.value]);
                                                                        }else{
                                                                            setFieldValue("personalInsurance", [item.value]);
                                                                        }
                                                                    } else {
                                                                        setFieldValue("personalInsurance", values.personalInsurance.filter((v) => v !== item.value));
                                                                    }
                                                                    if (values["businessInsurance"] !== "") {
                                                                        setFieldValue("businessInsurance", "");
                                                                    }
                                                                    if(!(values["personalInsurance"] && values["personalInsurance"].includes("Mortgage Protection"))){
                                                                        setFieldValue("mortgageAmount", "");
                                                                    }

                                                                }}
                                                        />}
                                                        label={<label className="displayF">
                                                            <Typography variant="body1"
                                                                        className="mb0">{item.label}
                                                            </Typography> {
                                                                item.label == "Great Wealth Transfer" &&
                                                                <HtmlTooltip
                                                                        title={
                                                                            <React.Fragment>
                                                                                <Typography
                                                                                        className="f16 txtWhite mb0"
                                                                                >
                                                                                    A gift tax
                                                                                    is a tax on
                                                                                    the transfer
                                                                                    of property
                                                                                    by one
                                                                                    individual
                                                                                    to
                                                                                    another
                                                                                    while
                                                                                    receiving
                                                                                    nothing, or
                                                                                    less than
                                                                                    full value,
                                                                                    in return.
                                                                                    If
                                                                                    you are
                                                                                    paying
                                                                                    premiums for
                                                                                    another
                                                                                    party other
                                                                                    than your
                                                                                    spouse, it
                                                                                    may
                                                                                    be
                                                                                    considered a
                                                                                    gift or
                                                                                    transfer of
                                                                                    wealth and
                                                                                    may be
                                                                                    subject to
                                                                                    tax,
                                                                                    unless it is
                                                                                    within the
                                                                                    annual
                                                                                    exclusion
                                                                                    amount or
                                                                                    under the
                                                                                    lifetime
                                                                                    wealth
                                                                                    transfer
                                                                                    amount. Any
                                                                                    amounts
                                                                                    beyond the
                                                                                    approved
                                                                                    exclusion
                                                                                    amounts
                                                                                    would be
                                                                                    considered a
                                                                                    gift, and
                                                                                    the tax
                                                                                    applied
                                                                                    whether or
                                                                                    not the
                                                                                    donor
                                                                                    intends the
                                                                                    transfer to
                                                                                    be a gift.
                                                                                    NIW does not
                                                                                    give tax
                                                                                    advice or
                                                                                    guidance,
                                                                                    please
                                                                                    consult with
                                                                                    a tax
                                                                                    specialist
                                                                                    for advice.
                                                                                </Typography>
                                                                            </React.Fragment>
                                                                        }
                                                                >
                                                                    <Info
                                                                            className="icon"
                                                                            color="primary"
                                                                    />
                                                                </HtmlTooltip>
                                                        }</label>}
                                                />


                                            </Grid>);
                                })
                            }
                            <Grid item xs={12}>
                                {
                                        (touched && errors) &&
                                        <ErrorCommon
                                                errors={errors}
                                                name="personalInsurance"
                                                touched={touched}
                                        />
                                }
                            </Grid>
                        </Grid>
                    </FormGroup>
                </FormControl>

                {insuranceError &&
                        <p style={{ color: "#FF1744", fontSize: "12px" }}> Personal Insurance or
                            Business Insurance from both one is required </p>
                }
            </Grid>
    );
}
